// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"47e9b1a3","94":"f23f9e5f","389":"71933162","692":"530aafe0","895":"a09a19a2"}[chunkId] + ".chunk.js";
};